import { z } from 'zod/v4';

import { applicationRoleSchema } from './application-role.schema';

export const userProductRoleSchema = z.object({
  id: z.number().min(1),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().min(1),
  migratedToTrimbleIdentity: z.boolean(),
  lastLogin: z.string().nullable(),
  productRoles: z.array(
    z.object({
      product: z.object({
        id: z.number().min(1),
        name: z.string().min(1),
        displayName: z.string().min(1),
      }),
      role: applicationRoleSchema,
    })
  ),
});

export type UserProductRole = z.infer<typeof userProductRoleSchema>;
